import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const supportTickets = (state = initialState.supportTickets, action) => {
  switch (action.type) {
    case types.LOAD_SUPPORT_TICKETS_SUCCESS: {
      return action.supportTickets;
    }

    case types.UPDATE_SUPPORT_TICKET_SUCCESS:
      return [
        ...state.filter((tick) => tick.id !== action.supportTicket.id),
        { ...action.supportTicket }
      ];

    default:
      return state;
  }
};

export const supportTicket = (state = initialState.supportTicket, action) => {
  switch (action.type) {
    case types.GET_SUPPORT_TICKET_SUCCESS:
      return action.supportTicket;
    case types.CLEAR_SUPPORT_TICKET_SUCCESS:
      return {};
    default:
      return state;
  }
};

export const savingSupportTicket = (
  state = initialState.savingSupportTicket,
  action
) => {
  switch (action.type) {
    case types.SAVING_SUPPORT_TICKET:
      return action.supportTicket;

    default:
      return state;
  }
};

export const supportTicketsBoard = (
  state = initialState.supportTicketsBoard,
  action
) => {
  switch (action.type) {
    case types.LOAD_SUPPORT_TICKETS_BOARD_SUCCESS:
      return action.supportTicketsBoard;

    default:
      return state;
  }
};
